import axios, { AxiosError } from 'axios';
import Parse from 'parse';

import { captureException, captureMessage, setContext, setTag, SeverityLevel } from '@sentry/react';

type ErrorDetails = Record<string, any>;

export async function logToSentry(
  message: string | Error | Parse.Error | AxiosError,
  errorDetails: ErrorDetails = {},
  level: SeverityLevel = 'error',
  title?: string
) {
  setTag('source', 'rollbar-migration');
  if (title) {
    setTag('title', title);
  }
  if (axios.isAxiosError(message) || !!(message as AxiosError).config) {
    const axiosError = message as AxiosError;
    setContext('AxiosError', {
      message: axiosError.message,
      name: axiosError.name,
      code: axiosError.code,
      response: axiosError.response?.data
    });
    return captureMessage(axiosError.message, { level: level || 'error' });
  }
  if (errorDetails) {
    setContext('errorContext', errorDetails);
  }
  if (message instanceof Error || message instanceof Parse.Error) {
    return captureException(message, {
      level: level || 'error'
    });
  } else {
    return captureMessage(message, {
      level: level || 'error'
    });
  }
}

const sentry = {
  error: (message: string | Error, errorDetails?: ErrorDetails) =>
    logToSentry(message, errorDetails, 'error'),
  info: (message: string | Error, errorDetails?: ErrorDetails) =>
    logToSentry(message, errorDetails, 'info'),
  warning: (message: string | Error, errorDetails?: ErrorDetails) =>
    logToSentry(message, errorDetails, 'warning'),
  debug: (message: string | Error, errorDetails?: ErrorDetails) =>
    logToSentry(message, errorDetails, 'debug'),
  critical: (message: string | Error, errorDetails?: ErrorDetails) =>
    logToSentry(message, errorDetails, 'fatal')
};

export default sentry;
